<template>
  <div class="app-newsletter-unsubscribe">
    <div class="headline">
      <slot name="txtHeadline">Newsletter Abmelden</slot>
    </div>
    <b-overlay class="btn-next-overlay" :show="loading" spinner-large >
      <div class="content">
        <div class="unsubscribe-text-success text-center" v-if="unsubscribeStatus === 'success'">
          <span class="check-icon">&#10003;</span>
          <slot name="txtUnsubscribeSuccess">
            <h1> Der Newsletter wurde erfolgreich abbestellt! </h1>
          </slot>
        </div>
        <div class="unsubscribe-text-error text-center" v-if="unsubscribeStatus === 'failure'">
          <span class="sad-icon">&#9785;</span>
          <slot name="txtUnsubscribeError">
            <h1 class="error"> Hoppla, da gibts ein Problem! Bitte versuchen Sie erneut! </h1>
          </slot>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>

import gql from 'graphql-tag'
import urlParam from '@/mixins/urlParam'

export default {
  name: 'NewsletterUnsubscribe',
  data: function () {
    return {
      solicitorId: null,
      unsubscribeStatus: '',
      loading: false,
      brand: ''
    }
  },
  mixins: [
    urlParam
  ],
  created () {
    this.brand = this.$store.getters.brand
  },
  methods: {
    cancelSubscription () {
      this.$apollo.mutate({
        mutation: gql`mutation cancelSubscription ($input: CancelSubscriptionInput!){
        cancelSubscription (cancelSubscription: $input) {
          success
        }
      } `,
        variables: {
          input: {
            brand: this.brand,
            solicitorId: this.solicitorId,
            subscriptionType: 'EMA'
          }
        }
      })
        .then(response => {
          if (response.data.cancelSubscription.success === true) {
            this.unsubscribeStatus = 'success'
          } else {
            this.unsubscribeStatus = 'failure'
          }
          this.loading = false
        })
        .catch(() => {
          this.unsubscribeStatus = 'failure'
          this.loading = false
        })
    }
  },
  mounted () {
    this.loading = true
    const urlParam = this.getURLParam('solicitorId')
    this.solicitorId = urlParam

    if (urlParam !== null && urlParam !== '') {
      this.cancelSubscription()
    } else {
      this.unsubscribeStatus = 'failure'
      this.loading = false
    }
  }

}
</script>
